var _circle, _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path0, _path1, _mask6, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 36,
    fill: "#0098FF",
    fillOpacity: 0.1
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_308_2041",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.662 14.0695C69.3218 13.868 69.6961 13.1685 69.497 12.5074C69.2979 11.8464 68.6007 11.4742 67.941 11.6758C67.2813 11.8773 66.907 12.5768 67.1061 13.2379C67.3052 13.8989 68.0023 14.2711 68.662 14.0695Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.662 14.0695C69.3218 13.868 69.6961 13.1685 69.497 12.5074C69.2979 11.8464 68.6007 11.4742 67.941 11.6758C67.2813 11.8773 66.907 12.5768 67.1061 13.2379C67.3052 13.8989 68.0023 14.2711 68.662 14.0695Z",
    fill: "#0098FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7161 13.968C65.3142 15.954 67.406 17.0683 69.3833 16.4642L67.9407 11.6748C68.5986 11.4739 69.2961 11.8438 69.4961 12.5077L64.7161 13.968ZM67.2197 9.28107C65.2424 9.88515 64.1179 11.9821 64.7161 13.968L69.4961 12.5077C69.696 13.1716 69.3202 13.8695 68.6623 14.0704L67.2197 9.28107ZM71.887 11.7773C71.2888 9.79134 69.1971 8.677 67.2197 9.28107L68.6623 14.0704C68.0044 14.2714 67.3069 13.9015 67.107 13.2376L71.887 11.7773ZM67.107 13.2376C66.907 12.5737 67.2829 11.8758 67.9407 11.6748L69.3833 16.4642C71.3606 15.8601 72.4852 13.7632 71.887 11.7773L67.107 13.2376Z",
    fill: "#0098FF",
    mask: "url(#path-2-inside-1_308_2041)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_308_2041",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6791 19.8768C68.3388 19.6753 68.7132 18.9758 68.5141 18.3147C68.315 17.6537 67.6178 17.2815 66.9581 17.4831C66.2984 17.6846 65.9241 18.3841 66.1232 19.0452C66.3223 19.7062 67.0194 20.0784 67.6791 19.8768Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6791 19.8768C68.3388 19.6753 68.7132 18.9758 68.5141 18.3147C68.315 17.6537 67.6178 17.2815 66.9581 17.4831C66.2984 17.6846 65.9241 18.3841 66.1232 19.0452C66.3223 19.7062 67.0194 20.0784 67.6791 19.8768Z",
    fill: "#0098FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7331 19.7753C64.3313 21.7613 66.4231 22.8756 68.4004 22.2715L66.9578 17.4821C67.6157 17.2812 68.3132 17.6511 68.5132 18.315L63.7331 19.7753ZM66.2368 15.0884C64.2595 15.6924 63.135 17.7894 63.7331 19.7753L68.5132 18.315C68.7131 18.9789 68.3373 19.6768 67.6794 19.8777L66.2368 15.0884ZM70.9041 17.5846C70.3059 15.5986 68.2142 14.4843 66.2368 15.0884L67.6794 19.8777C67.0215 20.0787 66.324 19.7088 66.1241 19.0449L70.9041 17.5846ZM66.1241 19.0449C65.9241 18.381 66.3 17.6831 66.9578 17.4821L68.4004 22.2715C70.3777 21.6674 71.5022 19.5705 70.9041 17.5846L66.1241 19.0449Z",
    fill: "#0098FF",
    mask: "url(#path-4-inside-2_308_2041)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_308_2041",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8546 8.79372C59.5144 8.59217 59.8887 7.89264 59.6896 7.23162C59.4905 6.57059 58.7934 6.19839 58.1336 6.39994C57.4739 6.60149 57.0996 7.30102 57.2987 7.96204C57.4978 8.62307 58.1949 8.99526 58.8546 8.79372Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8546 8.79372C59.5144 8.59217 59.8887 7.89264 59.6896 7.23162C59.4905 6.57059 58.7934 6.19839 58.1336 6.39994C57.4739 6.60149 57.0996 7.30102 57.2987 7.96204C57.4978 8.62307 58.1949 8.99526 58.8546 8.79372Z",
    fill: "#0098FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9087 8.69219C55.5068 10.6781 57.5986 11.7925 59.5759 11.1884L58.1334 6.39903C58.7912 6.19805 59.4887 6.56799 59.6887 7.23189L54.9087 8.69219ZM57.4124 4.00525C55.435 4.60933 54.3105 6.70625 54.9087 8.69219L59.6887 7.23189C59.8887 7.89579 59.5128 8.59365 58.8549 8.79463L57.4124 4.00525ZM62.0796 6.50147C61.4814 4.51552 59.3897 3.40118 57.4124 4.00525L58.8549 8.79463C58.1971 8.99561 57.4996 8.62567 57.2996 7.96177L62.0796 6.50147ZM57.2996 7.96177C57.0996 7.29786 57.4755 6.60001 58.1334 6.39903L59.5759 11.1884C61.5533 10.5843 62.6778 8.48741 62.0796 6.50147L57.2996 7.96177Z",
    fill: "#0098FF",
    mask: "url(#path-6-inside-3_308_2041)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_308_2041",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4279 23.9252C64.0876 23.7237 64.4619 23.0241 64.2628 22.3631C64.0637 21.7021 63.3666 21.3299 62.7069 21.5314C62.0472 21.733 61.6728 22.4325 61.8719 23.0935C62.071 23.7546 62.7682 24.1267 63.4279 23.9252Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4279 23.9252C64.0876 23.7237 64.4619 23.0241 64.2628 22.3631C64.0637 21.7021 63.3666 21.3299 62.7069 21.5314C62.0472 21.733 61.6728 22.4325 61.8719 23.0935C62.071 23.7546 62.7682 24.1267 63.4279 23.9252Z",
    fill: "#0098FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4819 23.8237C60.0801 25.8096 62.1718 26.924 64.1492 26.3199L62.7066 21.5305C63.3645 21.3295 64.062 21.6995 64.2619 22.3634L59.4819 23.8237ZM61.9856 19.1367C60.0083 19.7408 58.8838 21.8377 59.4819 23.8237L64.2619 22.3634C64.4619 23.0273 64.086 23.7251 63.4282 23.9261L61.9856 19.1367ZM66.6529 21.633C66.0547 19.647 63.9629 18.5327 61.9856 19.1367L63.4282 23.9261C62.7703 24.1271 62.0728 23.7572 61.8728 23.0933L66.6529 21.633ZM61.8728 23.0933C61.6729 22.4293 62.0487 21.7315 62.7066 21.5305L64.1492 26.3199C66.1265 25.7158 67.251 23.6189 66.6529 21.633L61.8728 23.0933Z",
    fill: "#0098FF",
    mask: "url(#path-8-inside-4_308_2041)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-5_308_2041",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6034 12.842C55.2632 12.6405 55.6375 11.941 55.4384 11.2799C55.2393 10.6189 54.5422 10.2467 53.8824 10.4483C53.2227 10.6498 52.8484 11.3493 53.0475 12.0104C53.2466 12.6714 53.9437 13.0436 54.6034 12.842Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6034 12.842C55.2632 12.6405 55.6375 11.941 55.4384 11.2799C55.2393 10.6189 54.5422 10.2467 53.8824 10.4483C53.2227 10.6498 52.8484 11.3493 53.0475 12.0104C53.2466 12.6714 53.9437 13.0436 54.6034 12.842Z",
    fill: "#0098FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6575 12.7405C51.2556 14.7265 53.3474 15.8408 55.3247 15.2367L53.8821 10.4474C54.54 10.2464 55.2375 10.6163 55.4375 11.2802L50.6575 12.7405ZM53.1611 8.05358C51.1838 8.65765 50.0593 10.7546 50.6575 12.7405L55.4375 11.2802C55.6374 11.9441 55.2616 12.642 54.6037 12.843L53.1611 8.05358ZM57.8284 10.5498C57.2302 8.56385 55.1385 7.4495 53.1611 8.05358L54.6037 12.843C53.9458 13.0439 53.2483 12.674 53.0484 12.0101L57.8284 10.5498ZM53.0484 12.0101C52.8484 11.3462 53.2243 10.6483 53.8821 10.4474L55.3247 15.2367C57.302 14.6327 58.4266 12.5357 57.8284 10.5498L53.0484 12.0101Z",
    fill: "#0098FF",
    mask: "url(#path-10-inside-5_308_2041)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M57.652 22.93C58.3117 22.7285 58.6861 22.0289 58.487 21.3679C58.2879 20.7069 57.5907 20.3347 56.931 20.5362C56.2713 20.7378 55.897 21.4373 56.0961 22.0983C56.2952 22.7594 56.9923 23.1316 57.652 22.93Z",
    fill: "#0098FF"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-6_308_2041",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.6303 9.78906C65.29 9.58751 65.6643 8.88798 65.4652 8.22696C65.2661 7.56594 64.569 7.19374 63.9093 7.39529C63.2495 7.59684 62.8752 8.29637 63.0743 8.95739C63.2734 9.61841 63.9706 9.99061 64.6303 9.78906Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6303 9.78906C65.29 9.58751 65.6643 8.88798 65.4652 8.22696C65.2661 7.56594 64.569 7.19374 63.9093 7.39529C63.2495 7.59684 62.8752 8.29637 63.0743 8.95739C63.2734 9.61841 63.9706 9.99061 64.6303 9.78906Z",
    fill: "#0098FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6843 9.68754C61.2825 11.6735 63.3742 12.7878 65.3516 12.1837L63.909 7.39437C64.5669 7.1934 65.2644 7.56334 65.4643 8.22724L60.6843 9.68754ZM63.188 5.0006C61.2107 5.60468 60.0861 7.70159 60.6843 9.68754L65.4643 8.22724C65.6643 8.89114 65.2884 9.589 64.6306 9.78998L63.188 5.0006ZM67.8552 7.49681C67.2571 5.51087 65.1653 4.39653 63.188 5.0006L64.6306 9.78998C63.9727 9.99095 63.2752 9.62101 63.0752 8.95711L67.8552 7.49681ZM63.0752 8.95711C62.8753 8.29321 63.2511 7.59535 63.909 7.39437L65.3516 12.1837C67.3289 11.5797 68.4534 9.48276 67.8552 7.49681L63.0752 8.95711Z",
    fill: "#0098FF",
    mask: "url(#path-13-inside-6_308_2041)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6669 32.8944L29.0162 19.5975",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3029 36.1666L32.8099 40.6767",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4725 30.4309L37.7113 31.8067",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5771 12.1494L39.9273 27.7998",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8508 34.4746L44.1815 40.0632C44.2493 41.2102 43.8894 42.341 43.1732 43.2349L37.5043 50.3064C36.3674 51.7249 34.6893 52.5946 32.8806 52.7022L26.6056 53.0755C25.4212 53.1459 24.3442 53.7874 23.713 54.7974L21.913 57.6785",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58074 59.8779L9.06797 53.434C9.72264 52.231 11.2228 51.7902 12.4181 52.4491L21.9875 57.7194C23.1838 58.3783 23.6226 59.8873 22.9679 61.0893L19.4462 68.7687",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4183 9.82338L35.1021 8.58537C35.2501 8.31841 35.526 8.13082 35.8514 8.11146C35.9697 8.10443 36.0847 8.12072 36.1917 8.15507L48.3763 12.0549C48.6117 12.1306 48.8066 12.2995 48.9172 12.5205L52.0492 18.8113C52.1035 18.92 52.1374 19.042 52.1451 19.1711C52.1558 19.3527 52.1136 19.5255 52.0313 19.6738L42.2953 37.2885C41.1152 39.423 38.9453 40.3127 33.1772 40.6558C29.9751 40.8463 23.9984 41.0056 23.9053 39.4326C23.8891 39.1588 23.9934 38.9166 24.1723 38.7366L30.9685 31.8729C31.4139 31.4235 31.6736 30.7909 31.6331 30.1068C31.5578 28.8334 30.4709 27.8627 29.2049 27.938C28.7594 27.9645 28.3517 28.1173 28.0127 28.3587L20.1855 33.9531C16.7591 36.4017 14.6475 40.2516 14.2294 44.4588C13.9095 47.6812 12.9865 50.8793 12.2058 52.347",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2076 12.7762C35.0718 10.4813 33.6445 7.31745 31.2133 7.46206C29.2268 7.58023 28.5655 9.35634 28.6405 10.6242C28.7905 13.1579 30.1211 14.5333 31.6609 15.0265L44.6821 19.1958L48.2902 26.4428",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6609 15.0265C30.6594 14.7058 28.8194 14.0815 27.5204 14.1588C25.9418 14.2527 24.3093 15.1622 24.4251 17.1188C24.5137 18.6171 26.1215 19.7938 28.2556 19.6668C32.3057 19.4259 35.4718 17.2426 35.2076 12.7762C35.1906 12.4895 35.1535 12.1891 35.0968 11.8834",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 57H54.5",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 57H64.5",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 60V64",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 50V54",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12H9.5",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12H19.5",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15V19",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5V9",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageIcon);
export default __webpack_public_path__ + "static/media/package-icon.5e70b284e69705cbb6d3f48be5cbe131.svg";
export { ForwardRef as ReactComponent };